/**
 * Shared client-side auth constants for the organisation (user) and volunteer
 * sessions.
 *
 * The access + refresh tokens live in httpOnly cookies set by the backend and
 * are never accessible to JS. Only the non-sensitive user/volunteer object is
 * persisted client-side, for optimistic hydration on reload (revalidated
 * against the relevant /me endpoint on boot).
 */

/** localStorage keys holding the persisted (non-sensitive) session user. */
export const AUTH_STORAGE_KEYS = {
  USER: "eventsPlanner.auth.user",
  VOLUNTEER_USER: "eventsPlanner.volunteer.auth.user",
} as const;
